var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.85,0h-13V18H4.15v2l1.34-.89L6.83,20V18h9a1.34,1.34,0,0,0,1.33-1.34V1.34A1.34,1.34,0,0,0,15.85,0ZM3.49.67h9.35v5H3.49Zm9.35,11H3.49V6.35h9.35ZM6.16,18.75l-.67-.44-.67.44V18H6.16Zm.67-1.38H3.49v-5h9.35v5Zm6.68,0V.67h1v16.7Zm1.67-11h1.33V11.7H15.18ZM16.51,16.7a.66.66,0,0,1-.66.67h-.67v-5h1.33Zm-1.33-11v-5h.67a.66.66,0,0,1,.66.67V5.68Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBookings);
export default __webpack_public_path__ + "static/media/my-bookings.2f0f1da5b549f182182c124627874a1c.svg";
export { ForwardRef as ReactComponent };